import { type RootState } from "app";

export const selectPeekUndo = (state: RootState) => state.undoRedo.undoStack.at(-1);
export const selectPeekRedo = (state: RootState) => state.undoRedo.redoStack.at(-1);
export const selectIsUndoEmpty = (state: RootState) => state.undoRedo.undoStack.length === 0;
export const selectIsRedoEmpty = (state: RootState) => state.undoRedo.redoStack.length === 0;
export const selectCanClear = (state: RootState) => selectIsUndoEmpty(state) && selectIsRedoEmpty(state);
export const selectPeekAllUndo = (state: RootState) => state.undoRedo.undoStack;
export const selectPeekAllRedo = (state: RootState) => state.undoRedo.redoStack;
